export const addStep = {
    add: "HINZFÜGEN",
}